import { render } from "./substance.vue?vue&type=template&id=74b15c7e&scoped=true"
import script from "./substance.vue?vue&type=script&lang=js"
export * from "./substance.vue?vue&type=script&lang=js"

import "./substance.vue?vue&type=style&index=0&id=74b15c7e&lang=scss&scoped=true"
import "./substance.vue?vue&type=style&index=1&id=74b15c7e&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b15c7e"]])

export default __exports__